// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-token-page {
  margin-top: 1.25rem;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.5);
  padding: 20px;
  margin-bottom: 2rem; }
  .my-token-page__card-wrapper {
    padding-top: 20px; }
  .my-token-page__card-head {
    text-align: center;
    color: #340c5a; }
  .my-token-page__card-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px; }
  .my-token-page__card-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px; }
    .my-token-page__card-content:last-child {
      margin-bottom: 0; }
  .my-token-page__token-balance {
    display: flex;
    align-items: flex-start;
    flex-basis: 100%; }
  .my-token-page__token-balance-info {
    flex-grow: 1; }
  .my-token-page__token-balance-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #340c5a; }
  .my-token-page__token-balance-note {
    font-size: 14px;
    color: #777; }
  .my-token-page__token-balance-action {
    display: inline-block;
    padding: 10px 20px;
    background-color: #007bff;
    color: #ffffff;
    text-decoration: none;
    border-radius: 5px;
    font-weight: bold;
    transition: background-color 0.3s ease; }
    .my-token-page__token-balance-action:hover {
      background-color: #0056b3; }
  .my-token-page__buy-button {
    background-color: #ff2481;
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.3s ease; }
    .my-token-page__buy-button:hover {
      background-color: #e02574 !important;
      color: white; }
  .my-token-page__total-token-amount {
    display: flex;
    align-items: flex-start;
    flex-basis: 100%;
    color: #340c5a; }
  .my-token-page__total-token-amount-info {
    flex-grow: 1; }
  .my-token-page__total-token-amount-title {
    font-size: 18px;
    font-weight: bold;
    color: #340c5a;
    margin-bottom: 10px; }
  .my-token-page__total-token-amount-value, .my-token-page__total-contributed-amount, .my-token-page__token-balance-amount {
    font-size: 24px;
    color: #340c5a;
    font-weight: bold; }
  .my-token-page__token-details {
    flex-basis: 30%; }
  .my-token-page__token-list {
    list-style: none;
    padding: 0; }
    .my-token-page__token-list li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      gap: 10px; }
    .my-token-page__token-list__token-title {
      font-size: 14px;
      font-weight: bold; }
    .my-token-page__token-list__token-amount {
      font-size: 14px;
      color: #777; }
  .my-token-page__total-contributed {
    display: flex;
    color: #340c5a;
    align-items: flex-start;
    flex-basis: 50%; }
  @media (max-width: 768px) {
    .my-token-page__total-contributed-info {
      display: flex;
      flex-direction: column;
      text-align: center; } }
  .my-token-page__total-contributed-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px; }
  .my-token-page__card-separator {
    border-bottom: 2px solid #757179;
    margin-bottom: 20px; }
  @media (max-width: 768px) {
    .my-token-page__card-content {
      flex-direction: column;
      align-items: center; }
    .my-token-page__token-balance {
      flex-direction: column;
      align-items: center; }
    .my-token-page__total-token-amount, .my-token-page__total-contributed {
      flex-direction: column;
      align-items: center; } }
  @media (max-width: 768px) {
    .my-token-page__token-details {
      margin-top: 20px;
      flex-basis: 100%; } }
  .my-token-page__token-amount {
    font-size: 18px;
    color: #777;
    font-weight: bold; }
`, "",{"version":3,"sources":["webpack://./src/styles/pages/mytoken.scss","webpack://./src/styles/variables/_variables.scss"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB,EAAA;EAEnB;IACE,iBAAiB,EAAA;EAGnB;IACE,kBAAkB;IAClB,cCC+B,EAAA;EDEjC;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB,EAAA;IAJpB;MAOG,gBAAgB,EAAA;EAIpB;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB,EAAA;EAGlB;IACE,YAAY,EAAA;EAGd;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cCjC+B,EAAA;EDoCjC;IACE,eAAe;IACf,WAAW,EAAA;EAGb;IACE,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC,EAAA;IARvC;MAWG,yBAAyB,EAAA;EAI7B;IACE,yBCrDgC;IDsDhC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC,EAAA;IAPvC;MAUG,oCAAmD;MACnD,YAAY,EAAA;EAIhB;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,cC3E+B,EAAA;ED8EjC;IACE,YAAY,EAAA;EAGd;IACE,eAAe;IACf,iBAAiB;IACjB,cCrF+B;IDsF/B,mBAAmB,EAAA;EAGrB;IAGE,eAAe;IACf,cC7F+B;ID8F/B,iBAAiB,EAAA;EAGnB;IACE,eAAe,EAAA;EAGjB;IACE,gBAAgB;IAChB,UAAU,EAAA;IAFX;MAKG,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,mBAAmB;MACnB,SAAS,EAAA;IAGX;MACE,eAAe;MACf,iBAAiB,EAAA;IAGnB;MACE,eAAe;MACf,WAAW,EAAA;EAIf;IACE,aAAa;IACb,cC9H+B;ID+H/B,uBAAuB;IACvB,eAAe,EAAA;EAIf;IADF;MAEI,aAAa;MACb,sBAAsB;MACtB,kBAAkB,EAAA,EAErB;EAED;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAA;EAGrB;IACE,gCAAgC;IAChC,mBAAmB,EAAA;EAGrB;IACE;MACE,sBAAsB;MACtB,mBAAmB,EAAA;IAGrB;MACE,sBAAsB;MACtB,mBAAmB,EAAA;IAGrB;MAEE,sBAAsB;MACtB,mBAAmB,EAAA,EACpB;EAID;IADF;MAEI,gBAAgB;MAChB,gBAAgB,EAAA,EAEnB;EAED;IACE,eAAe;IACf,WAAW;IACX,iBAAiB,EAAA","sourcesContent":["@import \"../variables/variables\";\n\n.my-token-page {\n  margin-top: 1.25rem;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  margin-bottom: 2rem;\n\n  &__card-wrapper {\n    padding-top: 20px;\n  }\n\n  &__card-head {\n    text-align: center;\n    color: $tokenContainerBorderColor;\n  }\n\n  &__card-title {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n\n  &__card-content {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 20px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &__token-balance {\n    display: flex;\n    align-items: flex-start;\n    flex-basis: 100%;\n  }\n\n  &__token-balance-info {\n    flex-grow: 1;\n  }\n\n  &__token-balance-title {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    color:$tokenContainerBorderColor;\n  }\n\n  &__token-balance-note {\n    font-size: 14px;\n    color: #777;\n  }\n\n  &__token-balance-action {\n    display: inline-block;\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: #ffffff; \n    text-decoration: none;\n    border-radius: 5px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background-color: #0056b3;\n    }\n  }\n\n  &__buy-button {\n    background-color: $tokenButtonBackgroundColor;\n    padding: 10px 20px;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    text-decoration: none;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background-color: $tokenButtonHoverColor !important;\n      color: white;\n    }\n  }\n\n  &__total-token-amount {\n    display: flex;\n    align-items: flex-start;\n    flex-basis: 100%;\n    color:$tokenContainerBorderColor;\n  }\n\n  &__total-token-amount-info {\n    flex-grow: 1;\n  }\n\n  &__total-token-amount-title {\n    font-size: 18px;\n    font-weight: bold;\n    color:$tokenContainerBorderColor;\n    margin-bottom: 10px;\n  }\n\n  &__total-token-amount-value,\n  &__total-contributed-amount,\n  &__token-balance-amount {\n    font-size: 24px;\n    color:$tokenContainerBorderColor;\n    font-weight: bold;\n  }\n\n  &__token-details {\n    flex-basis: 30%;\n  }\n\n  &__token-list {\n    list-style: none;\n    padding: 0;\n\n    li {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 10px;\n      gap: 10px;\n    }\n\n    &__token-title {\n      font-size: 14px;\n      font-weight: bold;\n    }\n\n    &__token-amount {\n      font-size: 14px;\n      color: #777;\n    }\n  }\n\n  &__total-contributed {\n    display: flex;\n    color:$tokenContainerBorderColor;\n    align-items: flex-start;\n    flex-basis: 50%;\n  }\n\n  &__total-contributed-info {\n    @media (max-width: 768px) {\n      display: flex;\n      flex-direction: column;\n      text-align: center;\n    }\n  }\n\n  &__total-contributed-title {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n\n  &__card-separator {\n    border-bottom: 2px solid #757179;\n    margin-bottom: 20px;\n  }\n\n  @media (max-width: 768px) {\n    &__card-content {\n      flex-direction: column;\n      align-items: center;\n    }\n\n    &__token-balance {\n      flex-direction: column;\n      align-items: center;\n    }\n\n    &__total-token-amount,\n    &__total-contributed {\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n\n  &__token-details {\n    @media (max-width: 768px) {\n      margin-top: 20px;\n      flex-basis: 100%;\n    }\n  }\n\n  &__token-amount {\n    font-size: 18px;\n    color: #777;\n    font-weight: bold;\n  }\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
